import React from "react";
import Header from "./../Common/Header";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";
import ProjectsSection from "./../Elements/ProjectsSection";

var bnrimg = require("./../../images/banner/1.jpg");

class Projects extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content">
          {/* <Banner
            title="Building Tomorrow's Infrastructure Today"
            pagename="Our Projects"
            bgimage={bnrimg}
          /> */}
          <ProjectsSection />
        </div>
        <Footer />
      </>
    );
  }
}

export default Projects;
